import { Link } from 'react-router-dom';
import { useState } from 'react';
import Lightbox2 from './Lightbox2';
import { FaTachometerAlt, FaGasPump, FaCogs } from 'react-icons/fa';

export default function CarCard2({ car }) {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const fallbackImage = 'https://picsum.photos/1200/400?random=1';

  const getImageUrl = (image) => {
    if (!image) return fallbackImage;
    return image.startsWith('http') ? image : `${process.env.REACT_APP_API_URL}${image}`;
  };

  const formatValue = (value) => {
    return value != null ? value.toLocaleString('en-NG', { maximumFractionDigits: 2 }) : 'N/A';
  };

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow duration-300 max-w-sm mx-auto sm:max-w-xs flex flex-col">
      <div className="relative">
        <img
          src={car.images && car.images.length > 0 ? getImageUrl(car.images[0]) : fallbackImage}
          alt={`${car.make} ${car.model}`}
          className="w-full h-48 object-cover rounded-t-lg cursor-pointer"
          onClick={() => setIsLightboxOpen(true)}
          onError={(e) => {
            e.target.src = fallbackImage;
            e.target.alt = 'Image not available';
          }}
        />
        <button className="absolute top-2 right-2 bg-white rounded-full p-1 shadow-md hover:bg-gray-100">
          <span className="text-gray-600">⋮</span>
        </button>
      </div>
      <div className="p-4">
        <h3 className="text-lg font-semibold text-gray-800 truncate">{`${car.make} ${car.model} - ${car.year}`}</h3>
        <p className="text-sm text-gray-600 line-clamp-1">{car.car_description || 'No description'}</p>
        <div className="flex space-x-6 mt-2 text-sm text-gray-600">
          <div className="text-center">
            <FaTachometerAlt className="w-6 h-6 mx-auto mb-1 text-gray-700" />
            <span>{formatValue(car.mileage)} Miles</span>
          </div>
          <div className="text-center">
            <FaGasPump className="w-6 h-6 mx-auto mb-1 text-gray-700" />
            <span>{car.fuel_type || 'N/A'}</span>
          </div>
          <div className="text-center">
            <FaCogs className="w-6 h-6 mx-auto mb-1 text-gray-700" />
            <span>{car.transmission || 'N/A'}</span>
          </div>
        </div>
        <div className="flex justify-between items-center mt-4">
          <span className="text-xl font-bold text-gray-900">₦{formatValue(parseFloat(car.price || 0))}</span>
          <button
            onClick={() => setIsLightboxOpen(true)}
            className="text-blue-600 text-sm font-medium hover:underline"
          >
            View Details →
          </button>
        </div>
      </div>
      {isLightboxOpen && <Lightbox2 car={car} onClose={() => setIsLightboxOpen(false)} />}
    </div>
  );
}